module.exports = __webpack_public_path__ + "img/dryer-heat.2520640c.svg";